import React from "react";
import {useState,useEffect} from 'react';
import axios from "axios";
import configData from "../config.json";
import { Leave } from "../hrpages";
import { format } from "date-fns";
import * as Icon from 'react-bootstrap-icons';
import { useNavigate } from "react-router-dom";

const AcrEntry=()=>{

    const [inputData,setInputData]=useState([]);
    const [acrData,setAcrData]=useState([]);
    const navigate=useNavigate();

     const getAcrData = async () => {
          const response=await axios.get(configData.SERVER_URL+`/acrData/${localStorage.getItem('regEmail')}`)
          setAcrData(response.data);
        };

    useEffect(() => {      
        getAcrData();
    }, []);

    const handleInput=(e)=>{
        const {name,value}=e.target; 
        setInputData({...inputData,[name]:value}); 
    }

    const handleSubmit=async(e)=>{
        e.preventDefault();

        setInputData({...inputData,empNID: localStorage.getItem('regEmail')});
    
        let res=await axios.post(configData.SERVER_URL+'/acrDataPost',inputData);
        if(res.status===200){
            if(res.data===1){
            alert('Successfully Inserted');
            getAcrData();
            // navigate('/acr');
        }
        } else{
        alert('System Error');
        } 
    }


    return(
        <>
            <div className="card">
                <div className="card-header">ACR Information</div>
                <div className="card-body">
                    
                    {/* <div class="row well">
                        <label><h5>এসিআর এর সময়কাল</h5></label>
                        <div className="col-lg-2 col-md-2">শুরুর তারিখ
                          <input type="date" className="form-control" id="acrDateFrom" name="acrDateFrom" onChange={(e)=>{handleInput(e)}} value={inputData.acrDateFrom} required></input>
                        </div>
                        <div className="col-lg-2 col-md-2">শেষের তারিখ
                          <input type="date" className="form-control" id="acrDateTo" name="acrDateTo" onChange={(e)=>{handleInput(e)}} value={inputData.acrDateTo} required></input>
                        </div> 
                        <div className="col-lg-6 col-md-6">এনআইডি
                          <input type="text" className="form-control" id="empNID" name="empNID" value={localStorage.getItem('regEmail')} disabled></input>
                        </div>
                    </div>
                    <hr></hr>
                    <div class="row well">
                        <div className="col-lg-6 col-md-6">নামঃ
                          <input type="text" className="form-control" id="empName" name="empName" onChange={(e)=>{handleInput(e)}} value={inputData.empName} required></input>
                        </div>
                        <div className="col-lg-6 col-md-6">পদবীঃ
                          <input type="text" className="form-control" id="empDesignation" name="empDesignation" onChange={(e)=>{handleInput(e)}} value={inputData.empDesignation} required></input>
                        </div>
                    </div>
                    <hr/>
                    <div class="row well">
                        <div className="col-lg-2 col-md-2">
                            <button type="button" class="btn btn-info">
                                <span class="glyphicon glyphicon-search" onClick={(e)=>{handleSubmit(e)}}>Save</span>
                            </button>
                        </div>
                    </div> */}
                    <hr/>
                    <div class="row well">
                        <table class="table table-success table-hover small">               
                                        <thead>
                                          <tr>
                                            <th>ACR Year</th>
                                            <th>Date From</th>
                                            <th>Date To</th>
                                            <th>Name</th>
                                            <th>Designation</th>
                                            <th>NID</th>
                                            <th>DOCR Date</th>
                                          
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {
                                          acrData && acrData.length>0 && acrData.map((data)=>
                                          <tr align="right">
                                            <td align="left">{data.acrYear}</td>
                                            <td align="left">{data.acrDateFrom ? format(data.acrDateFrom,"dd-MM-yyyy") : ''}</td>
                                            <td align="left">{data.acrDateTo ? format(data.acrDateTo,"dd-MM-yyyy") : ''}</td>
                                            <td align="left">{data.empName}</td>
                                            <td align="left">{data.empDesignation}</td>
                                            <td align="left">{data.empNID}</td>
                                            <td align="left">{data.docrEntryDate ? format(data.docrEntryDate,"dd-MM-yyyy") : ''}</td>
                                            
                                          </tr>
                                          )} 
                                        </tbody>
                                      </table> 
                    </div>

                </div>
            </div>
        </>
    )
}

export default AcrEntry;